export class Log {
  //TODO sse The origin check is just a workaround - this assignment should be changed to isDevMode() from @angular/core again once optimization is enabled on prod
  private static _isDevMode: boolean = window.location.origin.includes("localhost");

  public static forceDeactivate() {
    this._isDevMode = false;
  }

  public static get isDevMode(): boolean {
    return this._isDevMode;
  }

  public static info(...message: any): void {
      console.info(...message);
  }

  public static warn(...message: any): void {
      console.warn(...message);
  }

  public static trace(...message: any): void {
      console.trace(...message);
  }

  public static error(...message: any): void {
      console.error(...message);
  }

  public static assert(test: boolean, ...message: any): boolean {
      console.assert(test, ...message);
    return test;
  }

  public static assertExists<T>(test: T | null | undefined, variableName: string = 'variable'): test is T {
    if (test == null) {
      console.warn(`Expected ${variableName} not to be null or undefined`);
      return false;
    }
    return true;
  }
}
